import { useQuery } from 'react-query';

import { fetchStores } from './api/store';
import { Store } from './api/types';

export const useStores = () => {
    return useQuery<Store[], Error>(['Stores'], async () => await fetchStores());
};

export const useStoreByOrganization = (organizationId: string) => {
    return useQuery<Store[], Error>(['Stores', organizationId], async () => {
        const data = await fetchStores();
        return data
            .filter((store) => {
                const orgId =
                    typeof store.organization === 'string'
                        ? store.organization
                        : (store.organization as any)?.id ?? (store.organization as any)?._id;
                return orgId === organizationId;
            })
            .sort((a, b) => a.code.localeCompare(b.code, undefined, { sensitivity: 'base' }));
    });
};
